export class EnderecoSisbi {
    bairro: Bairro;
    cdTipoEndereco: string;
    csOrigemEndereco: number;
    ctDependente: number;
    dsBairroEndereco: string;
    dsLograEndereco: string;
    idAglomeracao: number;
    idEndereco: number;
    idEstabelecimento: number;
    idEvento: number;
    idOrgao: number;
    idOrgaoExterno: number;
    idPessoa: number;
    idPropriedade: number;
    idServidor: number;
    idSubdistritoIbge: number;
    latitude: number;
    logradouro: Logradouro;
    longitude: number;
    nrComplemento: string;
    txComplementoEndereco: string;
    nrCep?: any;
    nmLogradouro?: any;
    nmBairro?: any;
    sgUf?: any;
    nmMunicipio?: any;

    static fromJson(jsonData: any): EnderecoSisbi {
        if (jsonData.bairro != null) {
            jsonData.bairro = Bairro.fromJson(jsonData.bairro);
        }
        if (jsonData.logradouro != null) {
            jsonData.logradouro = Logradouro.fromJson(jsonData.logradouro);
        }
        return Object.assign(new EnderecoSisbi(), jsonData);
    }
}

class Bairro {
    idBairro: string;
    municipio: Municipio;
    nmBairro: string;
    nmBairroAbreviado: string;

    static fromJson(jsonData: any): Bairro {
        if (jsonData.municipio != null) {
            jsonData.municipio = Municipio.fromJson(jsonData.municipio);
        }
        return Object.assign(new Bairro(), jsonData);
    }
}

export class Municipio {
    idMunicipio: number;
    nmMunicipio: string;
    uf: UF;

    static fromJson(jsonData: any): Municipio {
        if (jsonData.uf != null) {
            jsonData.uf = UF.fromJson(jsonData.uf);
        }
        return Object.assign(new Municipio(), jsonData);
    }
}

export class UF {
    cdUfIbge: string;
    cdUfRf: string;
    nmUf: string;
    sgRegiao: string;
    sgUf: string;

    static fromJson(jsonData: any): UF {
        return Object.assign(new UF(), jsonData);
    }
}

class Logradouro {
    idLogradouro: number;
    municipio: Municipio;
    nmLogradouro: string;
    nmLogradouroComplemento: string;
    nrCep: string;
    sgUf: string;
    txComplemento: string;

    static fromJson(jsonData: any): Logradouro {
        if (jsonData.municipio != null) {
            jsonData.municipio = Municipio.fromJson(jsonData.municipio);
        }
        return Object.assign(new Logradouro(), jsonData);
    }
}
